import React, { Suspense } from 'react'
const EnergyReportEmailLazy = React.lazy(() => import('../pages/energyReportEmail.page'))

export const energyReportEmail = [
  {
    path: 'energy-report-email',

    element: (
      <Suspense fallback={<div></div>}>
        <EnergyReportEmailLazy />
      </Suspense>
    ),
  },
]
